/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { parse } from "tldts";
import "../assets/Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBell,
  faEnvelope,
  faRightFromBracket,
  faBars, 
  faXmark,
  faCalculator,
  faCoins, 
} from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dateTime, setDateTime] = useState(new Date());
  const [companyName, setCompanyName] = useState(""); 
  const navigate = useNavigate();
  const timer = useRef(null);
  const INACTIVITY_LIMIT = 20 * 60 * 1000; 

  // Logout handler
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/", { replace: true });
    window.location.reload();
  };

  // Reset inactivity timer
  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(handleLogout, INACTIVITY_LIMIT);
  };

  // Track user activity for auto logout
  useEffect(() => {
    // enable only production side
     if (process.env.NODE_ENV !== "production") return;

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  
  useEffect(() => {
    const interval = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Fetch company info dynamically
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const hostname = window.location.hostname;
        const parsed = parse(hostname);
        const domain = parsed.domainWithoutSuffix || "";

        const response = await axios.get(
          "https://payyug.in/api/get-company",
          { params: { domain } }
        );
        const data = response.data;

        if (data && data.name) {
          const firstWord = data.name.split(" ")[0];
          setCompanyName(`${firstWord} Finance`);
        }
      } catch (err) {
        console.error("Error fetching company info:", err);
      }
    };

    fetchCompany();
  }, []);

  // Google Translate Integration
  useEffect(() => {
    const scriptId = "google-translate-script";
    if (!document.getElementById(scriptId)) {
      const addScript = document.createElement("script");
      addScript.id = scriptId;
      addScript.type = "text/javascript";
      addScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(addScript);
    }

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages:
            "en,hi,bn,gu,ta,te,ml,mr,kn,pa,ur",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };
  }, []);

  // Format date and time
  const day = dateTime.toLocaleDateString("en-US", { weekday: "long" });
  const date = dateTime.getDate();
  const month = dateTime.toLocaleDateString("en-US", { month: "long" });
  const year = dateTime.getFullYear();
  const time = dateTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <div className="header">
      
      <div className="header-top">
        <div className="header-date-time">
          {day}, {month} {date}, {year} {time}
        </div>
        <div className="header-top-right">
          <div id="google_translate_element"></div>
          <div className="ip-label">
            <span>Powered by </span>
            <span className="ip-dot"></span>
            <span> IP:</span>
          </div>
        </div>
      </div>

      
      <div className="header-bottom">
        
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
        </button>

        
        {/* <div className="header-company-name">{companyName}</div> */}
         <div className="header-company-name">Super Admin Dashboard</div>


        
        <div className={`header-buttons ${menuOpen ? "open" : ""}`}>
          <button
            className="header-button"
            title="Profile"
            onClick={() => navigate("/SuperAdminProfile")}
          >
            <FontAwesomeIcon icon={faUser} /> 
          </button>

          <button
            className="header-button"
            title="Calculator"
            onClick={() => navigate("/Calculator")}
          >
            <FontAwesomeIcon icon={faCalculator} /> 
          </button>
          <button
            className="header-button"
            title="Gold Rate"
            onClick={() => navigate("/GoldLoan/GoldRate")}
          >
            <FontAwesomeIcon icon={faCoins} /> 
          </button>

          {/* <button
            className="header-button"
            onClick={() => navigate("/Adminmessage")}
          >
            <FontAwesomeIcon icon={faEnvelope} /> Message
          </button> */}

          <button className="header-button" title="Logout" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} />
          </button>
        </div>
      </div>
    </div>
  );
}
